import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import VueGtag from "vue-gtag";
import {BootstrapVue} from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import InstantSearch from 'vue-instantsearch';

import config from './modules/config';
import data from './modules/data';

var _ = require('lodash');

Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(InstantSearch);
//Vue.use(arrayMove);




const store = new Vuex.Store({
    modules: {
        config,
        data
    }
});



//TODO: Provide option to reset / start again (clear localStorage)


const routes = [
    {
        path: '/dashboard',
        name: 'dashboard',
        component: require('./components/Dashboard').default,
        meta: {
            label: 'Dashboard',
            header: 'Dashboard'
        }
    },

    {
        path: '/decisions',
        name: 'decisions',
        component: require('./components/DefineDecision').default,
        meta: {
            label: 'Decision and Timing',
            header: '1 & 2. Define a decision and timing of the decision'
        }
    },
    {
        path: '/considerations',
        name: 'considerations',
        component: require('./components/DefineConsiderations').default,
        meta: {
            label: 'Considerations',
            header: '3. Define considerations'
        }
    },
    {
        path: '/conditions',
        name: 'conditions',
        component: require('./components/DefineConditions').default,
        meta: {
            label: 'Conditions',
            header: '4. Define conditions'
        }
    },
    {
        path: '/scores',
        name: 'scores',
        component: require('./components/DefineScores').default,
        meta: {
            label: 'Relative values',
            header: '5. Define Relative values'
        }
    },
    {
        path: '/decisiontable',
        name: 'decisiontable',
        component: require('./components/DefineDecisionTable').default,
        meta: {
            label: 'Decision Table',
            header: '6. Define decision table'
        }
    },
    {
        path: '/scoreassessment',
        name: 'scoreassessment',
        component: require('./components/ScoreAssessment').default,
        meta: {
            label: 'Decision Scores',
            header: '7. Decision Scores'
        }
    },
    {
        path: '/scenariotesting',
        name: 'scenariotesting',
        component: require('./components/ScenarioTesting').default,
        meta: {
            label: 'Scenario Testing',
            header: '8. Scenario Testing'
        }
    }
];

Vue.component('route-header', require('./components/RouteHeader.vue').default);
Vue.component('breadcrumb', require('./components/Breadcrumb.vue').default);
Vue.component('populate-matrix', require('./components/PopulateMatrix.vue').default);
Vue.component('dashboard', require('./components/Dashboard').default);
Vue.component('search', require('./components/Search.vue').default);

const router = new VueRouter({
    //mode: 'history',
    routes,
});

if(process.env.MIX_APP_ENV == 'production') {
    Vue.use(VueGtag, {
        config: {
            id: ['G-7S7F2Y6233']
        }
    }, router);
}

const app = new Vue({
    store,
    router,
    mounted: async function() {


        $('.consideration_select').on('change',function(e){
            $('.save-decision-btn').prop('disabled',true);
            $('.save-decision-btn').addClass('disabled');
            var total_score = 0;
            var all_considerations_selected = true;
            $('.consideration_select').each(function(){

                if($(this).val()!=''){
                    total_score+= parseInt($("option:selected", this).data('score'));
                }else{
                    all_considerations_selected = false;
                }
            });


            $('.decision_row').addClass('table-dark');
            $('.decision_row').removeClass('table-success');
            if(all_considerations_selected==true) {
                $('.save-decision-btn').prop('disabled',false);
                $('.save-decision-btn').removeClass('disabled');
                $('.total_score').html(total_score);//Display span
                $('.total_score_input').val(total_score) //Hidden inputs


                $('.decision_row').each(function(){


                    if($(this).data('upper_score')!='' && $(this).data('lower_score')!=''){
                        if(total_score >= parseInt($(this).data('lower_score')) && total_score <= parseInt($(this).data('upper_score'))){
                            $(this).addClass('table-success');
                            $(this).removeClass('table-dark');
                            return false;
                        }
                    }

                    if($(this).data('upper_score')!='' && $(this).data('lower_score')==''){
                        if(total_score<= parseInt($(this).data('upper_score'))){
                            $(this).addClass('table-success');
                            $(this).removeClass('table-dark');
                            return false;
                        }
                    }

                    if($(this).data('lower_score')!='' && $(this).data('upper_score')==''){
                        if(total_score> parseInt($(this).data('lower_score'))){
                            $(this).addClass('table-success');
                            $(this).removeClass('table-dark');
                            return false;
                        }
                    }

                })
            }else{
                $('.total_score').html('Pending');
            }
        });

        $('.decision_submit_form').on('submit',function(e){
            e.preventDefault();

            var selected_condition_ids = $('.consideration_select option:selected').map(function(i,el){
                return parseInt($(el).val());
            }).get();
            $.ajax({
                method: 'POST',
                url: '/matrices/'+$(this).data('matrix_id')+'/decision/'+$(this).data('decision_id')+'/save',
                dataType: 'json',
                data: {
                    _token:				$('meta[name="csrf-token"]').attr('content'),
                    total_score: parseInt($('.total_score').html()),
                    condition_ids: selected_condition_ids
                },
                success:function(data){
                    if(data.success==true){
                        $('.message').html('<div class="alert alert-success">'+data.message+'</div>')
                    }

                },
                error:(function(data){
                    if(data.responseJSON.message!=null) {
                        $('.message').html('<div class="alert alert-danger">' + data.responseJSON.message + '</div>');
                    }

                })

            });

        });

    }
}).$mount('#app');
